import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrInventoryKind.ts
var t = () => e("inventoryKind");
//#endregion
export { t as useTrInventoryKind };
